
import {Component, Prop, Vue} from "vue-property-decorator";
  import {ICar} from "@/modules/Car/interfaces/car.interface";
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
import {IAppState} from "@/interfaces/app-state.interface";

  @Component({})
  export default class BaseFormInfoField extends Vue {
    @Prop() propName: string;
    @Prop() label: string;
    @Prop() tooltip?: string;
    @Prop() classField?: string;
    @Prop() placeholder?: string;
    @Prop({default: 'string'}) type?: string;

    get storeState(): IAppState { return this.$store.state; }
    get formModel(): ICar.IEntity { return this.storeState.car.formData.formModel; }
    get startForm(): ICar.IEntity { return this.storeState.car.formData.startForm; }

    get userAccess(): IAuth.UserAccess { return this.storeState.auth.userAccess; }
    get viewMode() { return !this.userAccess.scCarMk; }

    get modelValue() { return this.formModel[this.propName]; }
    set modelValue(value) {
      this.$store.commit('car/setFormProperty', {
        formName: 'formModel',
        name: this.propName,
        value
      });
    };
  }
